import {
  SlRadioGroup
} from "./chunk.YRC2LFOR.js";

// src/components/radio-group/radio-group.ts
var radio_group_default = SlRadioGroup;
SlRadioGroup.define("sl-radio-group");

export {
  radio_group_default
};
